import { apiClient } from "@nabble/sdk";

export interface ModulePermission {
  key: string;
  description: string;
}

export interface AdminModule {
  id: string;
  parentId: string | null;
  version: string;
  enabled: boolean;
  permissions: ModulePermission[];
}

export function fetchModules(): Promise<AdminModule[]> {
  return apiClient<AdminModule[]>("/api/admin/modules");
}

export function setModuleEnabled(id: string, enabled: boolean): Promise<void> {
  return apiClient<void>(`/api/admin/modules/${id}`, { method: "POST", body: { enabled } });
}
